import type { ContactProps } from '@/components/landing-page/components/contact';

export const defaults: Required<ContactProps> = {
  sidebar: false,
  title: 'Sie haben noch Fragen?',
  main: 'Vereinbaren Sie jetzt kostenlos und unverbindliches Erstgepräch',
  button: 'Kontaktieren Sie uns',
  success: 'Vielen Dank, wir haben Ihre Anfrage erhalten.',
};
